import MarketApi from '@api/marketing'
import Api from '@api/mo_fei'
// import { Modal } from 'hljd'
import { isUltimate } from '@merchant-backend/util'
import { action, observable } from 'mobx'

class Store {
  @observable loading = true
  @observable showModal = false

  @observable isGeren = false // 是否是个人 shop_type === 0 个人 5 团队
  @observable isOpened = false
  @observable purchaseData = {}
  @observable payMoney = '' // 支付金额

  @action
  getMerchantInfo = async () => {
    this.isGeren = Number(
      JSON.parse(sessionStorage.getItem('merchant_info')).shop_type === 0
    )
    this.isOpened = isUltimate()
    const { data } = await Api.merchantInfo({
      is_pro: 2
    })
    this.payMoney = data.pro_pay_money.fee
  }

  @action
  getPurchaseData = async () => {
    const { data } = await MarketApi.getShopProductPrice()
    this.purchaseData = data
  }
}

export default Store
